export default __webpack_public_path__ + "091ceff1b3da09099141dd6e515b111c.png";